export enum QuizType {
    Phone = 'phone',
    ReschedulesCancels = 'reschedules-cancels',
    SaleTheory = 'sale-theory',
    Leadership = 'leadership',
    BuildingClientBase = 'building-client-base',
}